import { IPaginationResponse } from '../../../../core';
import {
  IInboxNotificationResponse,
  IMarkAllNotificationsAsSeenResponse,
  INotificationLookupResponse,
  IUnseenNotificationsCountResponse
} from '../dtos';

const notificationId = '6f0e3c1a-8a5b-4f0e-9b8e-2f1f5c0d7a11';
const violationId = '5326fac9-b1aa-4949-88c8-15bfd5523904';

const inboxNotificationResponse: IInboxNotificationResponse = {
  id: notificationId,
  createdOnUtc: '2026-10-05T16:52:21.476Z',
  channel: 'PushNotification',
  sourceType: 'Violation',
  sourceId: violationId,
  title: 'Violation Created',
  body: 'Created violation has been recorder to your vehicle A 1.',
  isSeen: false,
  seenOnUtc: null
};

const inboxNotificationsResponse: IPaginationResponse<IInboxNotificationResponse> = {
  items: [
    inboxNotificationResponse,
    {
      ...inboxNotificationResponse,
      id: '1b9a6f42-0c1e-4b5a-9d3f-7e2a8c4d5f60',
      createdOnUtc: '2026-10-05T16:40:02.118Z',
      title: 'Violation Clamped',
      body: 'Clamped violation has been recorder to your vehicle A 1.',
      isSeen: true,
      seenOnUtc: '2026-10-05T17:01:44.902Z'
    }
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Descending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const unseenNotificationsCountResponse: IUnseenNotificationsCountResponse = { count: 1 };

const markAllNotificationsAsSeenResponse: IMarkAllNotificationsAsSeenResponse = { markedCount: 1 };

const notificationLookupResponse: INotificationLookupResponse = {
  channels: [
    { id: 'PushNotification', englishName: 'Push Notification', arabicName: 'إشعار فوري' },
    { id: 'EmailNotification', englishName: 'Email Notification', arabicName: 'إشعار بريد إلكتروني' },
    { id: 'SmsNotification', englishName: 'SMS Notification', arabicName: 'إشعار رسالة نصية' }
  ],
  sourceTypes: [
    { id: 'Subscription', englishName: 'Subscription', arabicName: 'اشتراك' },
    { id: 'Reservation', englishName: 'Reservation', arabicName: 'حجز' },
    { id: 'LoadWallet', englishName: 'Load Wallet', arabicName: 'تحميل المحفظة' },
    { id: 'OffStreetReservation', englishName: 'Off Street Reservation', arabicName: 'حجز خارج الشارع' },
    { id: 'OnStreetReservation', englishName: 'On Street Reservation', arabicName: 'حجز على الشارع' },
    { id: 'Violation', englishName: 'Violation', arabicName: 'مخالفة' },
    { id: 'LostTicket', englishName: 'Lost Ticket', arabicName: 'تذكرة مفقودة' },
    { id: 'ValetTicket', englishName: 'Valet Ticket', arabicName: 'تذكرة صف السيارات' }
  ],
  statuses: [
    { id: 'Pending', englishName: 'Pending', arabicName: 'قيد الانتظار' },
    { id: 'Sent', englishName: 'Sent', arabicName: 'تم الإرسال' },
    { id: 'PartiallySent', englishName: 'Partially Sent', arabicName: 'تم الإرسال جزئيا' },
    { id: 'Failed', englishName: 'Failed', arabicName: 'فشل الإرسال' }
  ],
  deliveryStatuses: [
    { id: 'Pending', englishName: 'Pending', arabicName: 'قيد الانتظار' },
    { id: 'Sent', englishName: 'Sent', arabicName: 'تم الإرسال' },
    { id: 'Failed', englishName: 'Failed', arabicName: 'فشل الإرسال' }
  ],
  recipientTypes: [
    { id: 'User', englishName: 'User', arabicName: 'مستخدم' },
    { id: 'EmailTo', englishName: 'Email To', arabicName: 'مرسل إليه' },
    { id: 'EmailCc', englishName: 'Email Cc', arabicName: 'نسخة إلى' }
  ]
};

export const notificationsData = {
  notificationLookupResponse,
  inboxNotificationResponse,
  inboxNotificationsResponse,
  unseenNotificationsCountResponse,
  markAllNotificationsAsSeenResponse
};
